import { catalogoApi, comunApi } from '@/api'
import { CatalogoFiltroModel, CatalogoInterface, ICombo, IResponseElement } from '@/models'

const useCommonEndpoint = () => {
  const obtenerModalidades = async (tramiteCodigo: string) => {
    try {
      const { data } = await comunApi.get<ICombo>(`loadCatalogoNombre/${tramiteCodigo}`)

      return { ok: true, data, modalidades: data?.list || [] }
    } catch (error: any) {
      return { ok: false, message: error }
    }
  }

  const obtenerDistritos = async (provinciaId: number) => {
    try {
      const { data } = await comunApi.get<ICombo>(`loadDistrito/${provinciaId}`)

      return { ok: true, data, distritos: data?.list || [] }
    } catch (error: any) {
      return { ok: false, message: error }
    }
  }

  const obtenerEscuelas = async (facultadId: number | null) => {
    try {
      const { data } = await comunApi.get<ICombo>(`loadEscuela/${facultadId}`)

      return { ok: true, data, escuelas: data?.list || [] }
    } catch (error: any) {
      return { ok: false, message: error }
    }
  }

  const obtenerEspecialidades = async (escuelaId: number) => {
    try {
      const { data } = await comunApi.get<ICombo>(`loadEspecialidad/${escuelaId}`)

      return { ok: true, especialidades: data?.list || [] }
    } catch (error: any) {
      return { ok: false, message: error }
    }
  }

  const obtenerFacultades = async (universidadId: number | null) => {
    try {
      const { data } = await comunApi.get<ICombo>(`loadFacultad/${universidadId}`)

      return { ok: true, data, facultades: data?.list || [] }
    } catch (error: any) {
      return { ok: false, message: error }
    }
  }

  const obtenerProgramas = async (escuelaId: number | null) => {
    try {
      const { data } = await comunApi.get<ICombo>(`loadPrograma/${escuelaId}`)

      return { ok: true, data, programas: data?.list || [] }
    } catch (error: any) {
      return { ok: false, message: error }
    }
  }

  const obtenerProvincias = async (departamentoId: number) => {
    try {
      const { data } = await comunApi.get<ICombo>(`loadProvincia/${departamentoId}`)

      return { ok: true, data, provincias: data?.list || [] }
    } catch (error: any) {
      return { ok: false, message: error }
    }
  }

  const buscarCatalogo = async (catalogoFiltro: CatalogoFiltroModel) => {
    try {
      const { data } = await catalogoApi.post<IResponseElement<CatalogoInterface>>(`search`, catalogoFiltro)

      return { ok: true, data, response: data }
    } catch (error: any) {
      return { ok: false, message: error }
    }
  }

  return {
    buscarCatalogo,
    obtenerDistritos,
    obtenerEscuelas,
    obtenerEspecialidades,
    obtenerFacultades,
    obtenerModalidades,
    obtenerProgramas,
    obtenerProvincias,
  }
}

export default useCommonEndpoint
